/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FileUploadDto
 */
export interface FileUploadDto {
    /**
     * 
     * @type {string}
     * @memberof FileUploadDto
     */
    fileName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileUploadDto
     */
    contentB64?: string | null;
}

/**
 * Check if a given object implements the FileUploadDto interface.
 */
export function instanceOfFileUploadDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FileUploadDtoFromJSON(json: any): FileUploadDto {
    return FileUploadDtoFromJSONTyped(json, false);
}

export function FileUploadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FileUploadDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fileName': !exists(json, 'fileName') ? undefined : json['fileName'],
        'contentB64': !exists(json, 'contentB64') ? undefined : json['contentB64'],
    };
}

export function FileUploadDtoToJSON(value?: FileUploadDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fileName': value.fileName,
        'contentB64': value.contentB64,
    };
}

